import { Box, Grid, Button, Dialog, DialogContent } from "@mui/material"
import { PrismicRichText } from "@prismicio/react"
import useToggle from "../../hooks/useToggle"

import {
	TextLeftRight,
	ImageLeftTextRight,
	TextLeftImageRight,
	SmallImageLeftTextRight,
	HinweisElement,
	DownloadElement,
	FullWidthImage,
} from "../../typings/Content"

import Icon from "@mdi/react"
import { mdiPlaylistCheck, mdiDownload } from "@mdi/js"

export const SliceZoneItem = ({ item }: SliceZoneItemProps) => {
	const { type } = item

	switch (type) {
		case "text":
			return <PrismicRichText field={item.primary.text} />
		case "text1":
			return <TextLeftRightItem item={item} />
		case "bild_links_text_rechts":
			return <ImageLeftTextRightItem item={item} />
		case "text_links_bild_rechts":
			return <TextLeftImageRightItem item={item} />
		case "kleines_bild_l_text_r":
			return <SmallImageLeftTextRightItem item={item} />
		case "hinweis_element":
			return <HinweisElementItem item={item} />
		case "download_element":
			return <DownloadElementItem item={item} />
		case "bild_ganze_breite":
			return <FullWidthImageItem item={item} />
		default:
			return null
	}
}

interface SliceZoneItemProps {
	item: any
}

// 2 columns: Both Text
export const TextLeftRightItem = ({ item }: TextLeftRightProps) => {
	const {
		primary: { leftcolumn, rightcolumn },
	} = item

	return (
		<Box my={3}>
			<Grid container spacing={3}>
				<Grid item xs={12} md={6}>
					<PrismicRichText field={leftcolumn as any} />
				</Grid>
				<Grid item xs={12} md={6}>
					<PrismicRichText field={rightcolumn as any} />
				</Grid>
			</Grid>
		</Box>
	)
}

interface TextLeftRightProps {
	item: TextLeftRight
}

// 2 columns: Image Left Text Right
export const ImageLeftTextRightItem = ({ item }: ImageLeftTextRightProps) => {
	const [isOpen, toggleIsOpen] = useToggle()
	const {
		primary: {
			image: { alt, url },
			text,
		},
	} = item

	return (
		<Box my={2}>
			<Grid container spacing={3}>
				<Grid item xs={12} md={6}>
					<div style={{ textAlign: "center" }}>
						<Button
							onClick={toggleIsOpen}
							style={{
								display: "flex",
								fontSize: "12px",
								paddingLeft: 0,
								textDecoration: "underline",
								cursor: "zoom-in",
							}}
						>
							<img
								src={url}
								alt={alt}
								style={{
									height: "100%",
									width: "100%",
									maxWidth: "500px",
									margin: "auto",
								}}
							/>
						</Button>
					</div>
				</Grid>
				<Grid item xs={12} md={6}>
					<PrismicRichText field={text as any} />
				</Grid>
			</Grid>
			<Dialog
				open={isOpen}
				onClose={toggleIsOpen}
				aria-labelledby="image"
				fullWidth
				maxWidth="lg"
			>
				<DialogContent>
					<img
						src={url}
						alt={alt}
						style={{
							height: "100%",
							maxHeight: 600,
							width: "100%",
							maxWidth: "100%",
							margin: "auto",
							objectFit: "contain",
						}}
					/>
				</DialogContent>
			</Dialog>
		</Box>
	)
}

interface ImageLeftTextRightProps {
	item: ImageLeftTextRight
}

// 2 columns: Text Left Image Right
export const TextLeftImageRightItem = ({ item }: TextLeftImageRightProps) => {
	const [isOpen, toggleIsOpen] = useToggle()
	const {
		primary: {
			image: { alt, url },
			text,
		},
	} = item
	return (
		<Box my={2}>
			<Grid container spacing={3}>
				<Grid item xs={12} md={6} style={{ position: "relative" }}>
					<PrismicRichText field={text as any} />
				</Grid>
				<Grid item xs={12} md={6}>
					<div style={{ textAlign: "center" }}>
						<Button
							onClick={toggleIsOpen}
							style={{
								display: "flex",
								fontSize: "12px",
								paddingLeft: 0,
								textDecoration: "underline",
								cursor: "zoom-in",
							}}
						>
							<img
								src={url}
								alt={alt}
								style={{
									height: "100%",
									width: "100%",
									maxWidth: "500px",
									margin: "auto",
								}}
							/>
						</Button>
					</div>
				</Grid>
			</Grid>
			<Dialog
				open={isOpen}
				onClose={toggleIsOpen}
				aria-labelledby="image"
				fullWidth
				maxWidth="lg"
			>
				<DialogContent>
					<img
						src={url}
						alt={alt}
						style={{
							height: "100%",
							maxHeight: 600,
							width: "100%",
							maxWidth: "100%",
							margin: "auto",
							objectFit: "contain",
						}}
					/>
				</DialogContent>
			</Dialog>
		</Box>
	)
}

interface TextLeftImageRightProps {
	item: TextLeftImageRight
}

// 2 columns: Small Image Left Text Right
export const SmallImageLeftTextRightItem = ({ item }: SmallImageLeftTextRightProps) => {
	const [isOpen, toggleIsOpen] = useToggle()
	const {
		primary: {
			image: { alt, url },
			text,
		},
	} = item

	return (
		<Box my={2}>
			<Grid container spacing={3}>
				<Grid item xs={12} md={3}>
					<Box
						mt={3}
						style={{
							textAlign: "center",
						}}
					>
						<Button
							onClick={toggleIsOpen}
							style={{
								display: "flex",
								fontSize: "12px",
								paddingLeft: 0,
								textDecoration: "underline",
								cursor: "zoom-in",
							}}
						>
							<img
								src={url}
								alt={alt}
								style={{
									height: "100%",
									width: "100%",
									maxWidth: "500px",
									margin: "auto",
								}}
							/>
						</Button>
					</Box>
				</Grid>
				<Grid item xs={12} md={9}>
					<PrismicRichText field={text as any} />
				</Grid>
			</Grid>
			<Dialog
				open={isOpen}
				onClose={toggleIsOpen}
				aria-labelledby="image"
				fullWidth
				maxWidth="lg"
			>
				<DialogContent>
					<img
						src={url}
						alt={alt}
						style={{
							height: "100%",
							maxHeight: 600,
							width: "100%",
							maxWidth: "100%",
							margin: "auto",
							objectFit: "contain",
						}}
					/>
				</DialogContent>
			</Dialog>
		</Box>
	)
}

interface SmallImageLeftTextRightProps {
	item: SmallImageLeftTextRight
}

// Hinweis Element
export const HinweisElementItem = ({ item }: HinweisElementItemProps) => {
	const {
		primary: { text },
	} = item

	return (
		<Box
			my={4}
			style={{
				textAlign: "center",
				border: "1px solid #7ABFAC",
				background: "rgba(122, 191, 172, 0.3)",
				padding: "1px",
				borderRadius: "4px",
			}}
		>
			<strong>
				<PrismicRichText field={text as any} />
			</strong>
		</Box>
	)
}

interface HinweisElementItemProps {
	item: HinweisElement
}

// Download Element
export const DownloadElementItem = ({ item }: DownloadElementItemProps) => {
	const {
		primary: { text, description, downloadlink },
	} = item

	return (
		<Grid container spacing={3}>
			<Grid item xs={12} md={3}>
				<Box
					style={{
						display: "flex",
						justifyContent: "space-evenly",
						alignItems: "center",
						width: "170px",
						background: "whitesmoke",
						border: "1px solid #7abfac",
						borderTopLeftRadius: 4,
						borderTopRightRadius: 4,
						borderBottom: "none",
						margin: "auto",
						marginTop: 20,
					}}
				>
					<Box pl={2} pt={1}>
						<Icon path={mdiPlaylistCheck} size={1} color="green" />
					</Box>
					<Box pr={2}>
						<strong>
							<PrismicRichText field={text as any} />
						</strong>
					</Box>
				</Box>
				<div style={{ margin: "auto", textAlign: "center" }}>
					<a
						href={downloadlink?.[0].text}
						target="_blank"
						rel="noopener noreferrer"
						style={{ textDecoration: "none" }}
					>
						<Button
							style={{
								padding: 1,
								marginLeft: 1,
								marginTop: -3,
								margin: "auto",
								textAlign: "center",
							}}
						>
							<Box
								style={{
									display: "flex",
									justifyContent: "space-between",
									alignItems: "center",
									width: "170px",
									background: "#7abfac",
									border: "1px solid #7abfac",
									borderBottomLeftRadius: 4,
									borderBottomRightRadius: 4,
									borderTop: "none",
								}}
							>
								<Box pl={2} py={1} mr={2} style={{ color: "white" }}>
									<strong>Download</strong>
								</Box>
								<Box px={2} pb={1} pt={2} style={{ background: "#599483" }}>
									<Icon path={mdiDownload} size={1} color="white" />
								</Box>
							</Box>
						</Button>
					</a>
				</div>
			</Grid>
			<Grid item xs={12} md={9}>
				<PrismicRichText field={description as any} />
			</Grid>
		</Grid>
	)
}

interface DownloadElementItemProps {
	item: DownloadElement
}

// 2 columns: Small Image Left Text Right
export const FullWidthImageItem = ({ item }: FullWidthImageProps) => {
	const [isOpen, toggleIsOpen] = useToggle()
	const {
		primary: {
			image: { alt, url },
		},
	} = item

	return (
		<Box my={5}>
			<Grid container spacing={3}>
				<Grid item xs={12}>
					<Button
						onClick={toggleIsOpen}
						style={{
							display: "flex",
							fontSize: "12px",
							paddingLeft: 0,
							textDecoration: "underline",
							cursor: "zoom-in",
						}}
					>
						<img
							src={url}
							alt={alt}
							style={{
								height: "100%",
								maxHeight: 480,
								width: "100%",
								maxWidth: "100%",
								margin: "auto",
								objectFit: "contain",
							}}
						/>
					</Button>
				</Grid>
			</Grid>
			<Dialog
				open={isOpen}
				onClose={toggleIsOpen}
				aria-labelledby="image"
				fullWidth
				maxWidth="lg"
			>
				<DialogContent>
					<img
						src={url}
						alt={alt}
						style={{
							height: "100%",
							maxHeight: 600,
							width: "100%",
							maxWidth: "100%",
							margin: "auto",
							objectFit: "contain",
						}}
					/>
				</DialogContent>
			</Dialog>
		</Box>
	)
}

interface FullWidthImageProps {
	item: FullWidthImage
}
